export const formatMoney = (value: number, decimals = 2) => {
  if (value !== undefined && value !== null) {
    return !isInteger(value)
      ? value
          .toFixed(decimals)
          .replace(".", ",")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
      : value
          .toString()
          .replace(".", ",")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
  }
};

const isInteger = (value: any) => {
  return value % 1 === 0;
};
